// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__ovU8f","btn_active":"styles_btn_active__RO4s1","pi":"styles_pi__a3uHE","label":"styles_label__Vza15","spinner":"styles_spinner__PZZZA"};